import React, { useState, useEffect } from 'react'
import {
  Card,
  Select,
  Switch,
  Button,
  Modal,
  Form,
  Table,
  message,
  Space,
  Checkbox
} from 'antd'
import { Picker as MobilePicker } from 'antd-mobile'
import styled from 'styled-components'
import moment from 'moment'
import { API_BASE_URL } from '../utils/apiutils'
import { useAuth } from '../hooks/AuthContext'
import api from '../utils/api'
import {
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
  CopyOutlined,
  DownOutlined
} from '@ant-design/icons'

const { Option } = Select

const Container = styled.div`
  max-width: 1200px;
  margin: 10px auto;
  padding: 10px;
  background: #fff;
  border-radius: 16px;
`

const IntervalSection = styled(Card)`
  margin-bottom: 32px;
  border-radius: 12px;
  border: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

  .ant-card-head {
    border-bottom: 1px solid #f0f0f0;
    padding: 16px 24px;
  }

  .ant-card-body {
    padding: 24px;
  }
`

const DayCard = styled(Card)`
  margin-bottom: 24px;
  border-radius: 12px;
  border: 1px solid #f0f0f0;
  transition: all 0.3s ease;

  .ant-card-body {
    padding: 20px;
  }

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  }
`

const DayHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  h3 {
    font-size: 18px;
    font-weight: 500;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 8px;

    .business-hours {
      font-size: 14px;
      color: #666;
      font-weight: normal;
    }
  }

  .controls {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .ant-switch {
    min-width: 44px;
    height: 22px;
    background-color: #bfbfbf;

    &.ant-switch-checked {
      background-color: #4caf50;
    }
  }
`

const AddPeriodButton = styled(Button)`
  width: 100%;
  height: 44px;
  margin-top: 16px;
  border-radius: 8px;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:hover {
    background: #f6f6f6;
  }

  .anticon {
    font-size: 16px;
  }
`

const ActionButton = styled(Button)`
  padding: 4px 8px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  color: #4096ff;
  background: #f0f0f0;
  gap: 4px;

  &.copy-btn {
    color: #000;
    &:hover {
      background: #f0f7ff;
    }
  }

  &.delete-btn {
    color: #ff4d4f;
    &:hover {
      background: #fff1f0;
    }
  }
`

const TimeTable = styled(Table)`
  .ant-table-thead > tr > th {
    background: #fafafa;
    font-weight: 500;
  }

  .ant-table-tbody > tr > td {
    padding: 12px 16px;
  }
`

const CopyModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 12px;
    overflow: hidden;
  }

  .ant-modal-header {
    padding: 20px 24px;
  }

  .ant-modal-body {
    padding: 0 24px 0px 24px !important;
  }

  .days-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 12px;
    margin: 16px 0;
  }
`

const DayCheckbox = styled(Checkbox)`
  width: 100%;
  padding: 10px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  transition: all 0.3s;

  &:hover {
    /* border-color: #4096ff; */
  }

  &.ant-checkbox-wrapper-checked {
    background: #f0f7ff;
    border-color: #4096ff;
  }
`
const ButtonGroup = styled.div`
  margin-top: 32px;
  display: flex;
  justify-content: center;
  gap: 16px;

  @media (max-width: 768px) {
    display: none;
  }
`

const StyledButton = styled(Button)`
  width: 100%;
  height: 50px;
  font-size: 16px;
  border-radius: 8px;
`

const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 12px;
    overflow: hidden;
  }

  .ant-modal-header {
    padding: 20px 24px;
  }

  .ant-modal-body {
    padding: 0 24px 0px 24px !important;
  }

  @media (max-width: 768px) {
    .ant-modal-body {
      padding: 16px;
    }

    .ant-form-item {
      margin-bottom: 16px;
    }
  }
`

const WarningText = styled.div`
  color: #ff4d4f;
  margin-bottom: 16px;
  padding: 8px 12px;
  background: #fff2f0;
  border: 1px solid #ffccc7;
  border-radius: 6px;
`

const MobileTimePicker = styled.div`
  .adm-picker {
    --height: 40px;
  }

  .time-picker-field {
    padding: 4px 11px;
    background-color: #ffffff;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &:focus {
      border-color: #40a9ff;
      box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
    }
  }
`

const FixedButtonContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 12px 16px;
  background: #fff;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);
  z-index: 1000;

  @media (min-width: 769px) {
    display: none;
  }
`

const ContentContainer = styled.div`
  @media (max-width: 768px) {
    padding-bottom: 80px;
  }
`

const generateTimeOptions = (interval) => {
  const times = []
  const start = moment().startOf('day')
  const end = moment().endOf('day')
  while (start <= end) {
    times.push(start.format('HH:mm'))
    start.add(interval, 'minutes')
  }
  return times
}

const useIsMobileView = () => {
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768)

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768)
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return isMobileView
}

const EmployeeWorkHours = ({ employeeId }) => {
  const [defaultInterval, setDefaultInterval] = useState(30)
  const [workHours, setWorkHours] = useState({})
  const [openingHours, setOpeningHours] = useState({})
  const [products, setProducts] = useState([])
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [currentDay, setCurrentDay] = useState('')
  const [currentPeriodIndex, setCurrentPeriodIndex] = useState(null)
  const [startOptions, setStartOptions] = useState([])
  const [endOptions, setEndOptions] = useState([])
  const [warningText, setWarningText] = useState('')
  const [form] = Form.useForm()
  const [isFormComplete, setIsFormComplete] = useState(false)
  const { user } = useAuth()
  const businessId = user.businessId
  const [isCopyModalVisible, setIsCopyModalVisible] = useState(false)
  const [selectedDayToCopy, setSelectedDayToCopy] = useState('')
  const [selectedDays, setSelectedDays] = useState([])
  const isMobileView = useIsMobileView()

  // 添加這個對象來映射中文到英文星期名
  const englishDays = {
    星期日: 'Sunday',
    星期一: 'Monday',
    星期二: 'Tuesday',
    星期三: 'Wednesday',
    星期四: 'Thursday',
    星期五: 'Friday',
    星期六: 'Saturday'
  }

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const workHoursResponse = await api.get(
          `${API_BASE_URL}/api/employees/${businessId}/${employeeId}/work-hours`
        )
        const workHoursData = workHoursResponse.data.data.workHours
        const openingHoursData = workHoursResponse.data.data.openingHours
        const intervalRaw = workHoursResponse.data.data.serviceInterval
        const loadedInterval =
          intervalRaw != null &&
          Number.isFinite(Number(intervalRaw)) &&
          Number(intervalRaw) > 0
            ? Number(intervalRaw)
            : 30
        setDefaultInterval(loadedInterval)

        // 將英文星期名轉換為中文
        const chineseDays = {
          Sunday: '星期日',
          Monday: '星期一',
          Tuesday: '星期二',
          Wednesday: '星期三',
          Thursday: '星期四',
          Friday: '星期五',
          Saturday: '星期六'
        }

        const convertedWorkHours = {}
        const convertedOpeningHours = {}

        for (const [day, data] of Object.entries(workHoursData)) {
          convertedWorkHours[chineseDays[day]] = data
        }

        for (const [day, data] of Object.entries(openingHoursData)) {
          convertedOpeningHours[chineseDays[day]] = data
        }

        setWorkHours(convertedWorkHours || {})
        setOpeningHours(convertedOpeningHours || {})

        const productsResponse = await api.get(
          `/api/business_B/${businessId}/products`
        )
        const productData = productsResponse.data.filter(
          (product) =>
            !product.isDisabled && product.stylists?.includes(employeeId)
        )
        setProducts(productData)

        // 過濾掉不再可用的服務
        for (const day in workHoursData) {
          if (workHoursData[day].periods) {
            workHoursData[day].periods.forEach((period) => {
              period.service = period.service.filter((serviceId) =>
                productData.some((product) => product._id === serviceId)
              )
            })
          }
        }

        setStartOptions(generateTimeOptions(loadedInterval))
      } catch (error) {
        console.error('Error fetching initial data:', error)
        message.error('Failed to fetch initial data.')
      }
    }

    fetchInitialData()
  }, [businessId, employeeId])

  const handleIntervalChange = (value) => {
    setDefaultInterval(value)
    setStartOptions(generateTimeOptions(value))
  }

  const handleSwitchChange = (day) => {
    setWorkHours((prev) => ({
      ...prev,
      [day]: { ...prev[day], enabled: !(prev[day]?.enabled ?? false) }
    }))
  }
  const handleAddPeriod = (day) => {
    setCurrentDay(day)
    setCurrentPeriodIndex(null)
    setIsModalVisible(true)
    setWarningText('') // 清除警告信息
  }

  const handleEditPeriod = (day, index) => {
    setCurrentDay(day)
    setCurrentPeriodIndex(index)
    const period = workHours[day]?.periods?.[index]
    if (period) {
      const filteredEndOptions = startOptions.filter((option) =>
        moment(option, 'HH:mm').isAfter(moment(period.start, 'HH:mm'))
      )
      setEndOptions(filteredEndOptions)
      form.setFieldsValue({
        start: period.start,
        end: period.end,
        service: period.service
      })
      setIsModalVisible(true)
      setWarningText('') // 清除警告信息
    } else {
      message.error('無法找到對應的工作時間段')
    }
  }

  const handleModalOk = () => {
    form.validateFields().then((values) => {
      let newPeriod = {
        start: values.start,
        end: values.end,
        service: values.service.includes('所有服務')
          ? products.map((p) => p._id)
          : values.service
      }

      setWorkHours((prev) => {
        let periods = [...(prev[currentDay]?.periods || [])]
        if (currentPeriodIndex !== null) {
          periods[currentPeriodIndex] = newPeriod
        } else {
          periods.push(newPeriod)
          periods = periods.sort((a, b) =>
            moment(a.start, 'HH:mm').isBefore(moment(b.start, 'HH:mm')) ? -1 : 1
          )
        }
        return {
          ...prev,
          [currentDay]: { ...prev[currentDay], periods, enabled: true }
        }
      })

      setIsModalVisible(false)
      form.resetFields()
      setWarningText('')
      setIsFormComplete(false)
    })
  }

  const handleModalCancel = () => {
    setIsModalVisible(false)
    form.resetFields()
    setWarningText('') // 清除警告信息
  }

  const handleStartChange = (value) => {
    const filteredEndOptions = startOptions.filter((option) =>
      moment(option, 'HH:mm').isAfter(moment(value, 'HH:mm'))
    )
    setEndOptions(filteredEndOptions)
    form.setFieldsValue({ end: undefined })
    if (form.getFieldValue('end')) {
      checkTimeInBusinessHours(value, form.getFieldValue('end'), currentDay)
    }
  }

  const handleEndChange = (value) => {
    checkTimeInBusinessHours(form.getFieldValue('start'), value, currentDay)
  }

  const checkTimeInBusinessHours = (start, end, day) => {
    const businessPeriods = openingHours[day]?.periods || []
    const isOutsideBusinessHours = businessPeriods.some(
      (bp) =>
        moment(start, 'HH:mm').isBefore(moment(bp.start, 'HH:mm')) ||
        moment(end, 'HH:mm').isAfter(moment(bp.end, 'HH:mm'))
    )

    if (isOutsideBusinessHours) {
      setWarningText('新增的時間不在店家營業時間內，請注意！')
    } else {
      setWarningText('')
    }
  }

  const handleDeletePeriod = (day, index) => {
    setWorkHours((prev) => {
      let periods = [...(prev[day]?.periods || [])]
      periods.splice(index, 1)
      return { ...prev, [day]: { ...prev[day], periods } }
    })
  }

  const handleSave = async () => {
    let hasWarning = false

    const englishWorkHours = Object.keys(englishDays).reduce(
      (acc, chineseDay) => {
        const englishDay = englishDays[chineseDay]
        const dayData = workHours[chineseDay] || { enabled: false, periods: [] }

        // 檢查是否啟用但沒有時段
        if (dayData.enabled && dayData.periods.length === 0) {
          message.warning(`${chineseDay}已啟用但沒有新增時段，將被設置為未啟用`)
          hasWarning = true
          dayData.enabled = false
        }

        acc[englishDay] = dayData
        return acc
      },
      {}
    )

    if (hasWarning) {
      // 如果有警告，更新本地狀態
      setWorkHours(
        Object.keys(englishDays).reduce((acc, chineseDay) => {
          acc[chineseDay] = englishWorkHours[englishDays[chineseDay]]
          return acc
        }, {})
      )

      // 給用戶一些時間查看警告消息
      await new Promise((resolve) => setTimeout(resolve, 2000))
    }

    try {
      await api.put(`/api/employees/${businessId}/${employeeId}/work-hours`, {
        workHours: englishWorkHours,
        serviceInterval: defaultInterval
      })
      message.success('工作時間已更新')
    } catch (error) {
      console.error('Error saving work hours:', error)
      message.error('更新失敗，請稍後再試')
    }
  }

  const handleFormChange = () => {
    const { start, end, service } = form.getFieldsValue()
    setIsFormComplete(start && end && service && service.length > 0)
  }

  const handleCopyPeriods = (sourceDay) => {
    setSelectedDayToCopy(sourceDay)
    setIsCopyModalVisible(true)
  }

  const handleCopyConfirm = () => {
    const sourcePeriods = workHours[selectedDayToCopy]?.periods || []

    selectedDays.forEach((targetDay) => {
      setWorkHours((prev) => ({
        ...prev,
        [targetDay]: {
          ...prev[targetDay],
          enabled: true,
          periods: [...sourcePeriods]
        }
      }))
    })

    setIsCopyModalVisible(false)
    setSelectedDays([])
    message.success('時段已成功複製')
  }

  const columns = (day) => [
    {
      title: '時間',
      dataIndex: 'time',
      key: 'time',
      render: (_, record) => (
        <span style={{ color: '#1a1a1a', fontWeight: 500 }}>
          {record.start} - {record.end}
        </span>
      )
    },
    {
      title: '服務項目',
      dataIndex: 'service',
      key: 'service',
      render: (_, record) => (
        <span>
          {record.service?.includes('所有服務')
            ? '所有服務'
            : record.service
                ?.map((id) => products.find((p) => p._id === id)?.name)
                .join(', ')}
        </span>
      )
    },
    {
      title: '操作',
      key: 'action',
      width: 120,
      render: (_, record, index) => (
        <Space>
          <ActionButton
            type='text'
            onClick={() => handleEditPeriod(day, index)}
          >
            <EditOutlined />
          </ActionButton>
          <ActionButton
            type='text'
            className='delete-btn'
            onClick={() => handleDeletePeriod(day, index)}
          >
            <DeleteOutlined />
          </ActionButton>
        </Space>
      )
    }
  ]

  const renderDayCard = (day, { periods }) => (
    <DayCard key={day}>
      <DayHeader>
        <h3>
          {day}
          <span className='business-hours'>
            營業時間：
            {openingHours[day]?.periods
              ?.map((period) => `${period.start} - ${period.end}`)
              .join(', ')}
          </span>
        </h3>
        <div className='controls'>
          <Switch
            checked={workHours[day]?.enabled || false}
            onChange={() => handleSwitchChange(day)}
          />
          <ActionButton
            type='text'
            className='copy-btn'
            onClick={() => handleCopyPeriods(day)}
            disabled={!workHours[day]?.enabled}
          >
            <CopyOutlined />
            複製時段
          </ActionButton>
        </div>
      </DayHeader>

      {workHours[day]?.enabled && (
        <>
          <TimeTable
            columns={columns(day)}
            dataSource={workHours[day]?.periods?.map((period, index) => ({
              key: index,
              ...period
            }))}
            pagination={false}
            size='middle'
          />
          <AddPeriodButton type='dashed' onClick={() => handleAddPeriod(day)}>
            <PlusOutlined /> 新增時段
          </AddPeriodButton>
        </>
      )}
    </DayCard>
  )

  // 為移動端準備時間選項
  const getMobileTimeColumns = () => {
    const hours = Array.from({ length: 24 }, (_, i) =>
      i.toString().padStart(2, '0')
    )
    const minutes = Array.from({ length: 60 / defaultInterval }, (_, i) =>
      (i * defaultInterval).toString().padStart(2, '0')
    )

    return [
      hours.map((h) => ({
        label: h,
        value: h
      })),
      minutes.map((m) => ({
        label: m,
        value: m
      }))
    ]
  }

  // 處理移動端時間選擇
  const handleMobileTimeSelect = (type, values) => {
    const timeString = `${values[0]}:${values[1]}`
    if (type === 'start') {
      form.setFieldsValue({ start: timeString })
      handleStartChange(timeString)
    } else {
      form.setFieldsValue({ end: timeString })
      handleEndChange(timeString)
    }
  }

  // 渲染時間選擇器
  const renderTimeSelector = (type, label, value) => {
    if (isMobileView) {
      return (
        <MobileTimePicker>
          <MobilePicker
            columns={getMobileTimeColumns()}
            value={value ? value.split(':') : []}
            onConfirm={(values) => handleMobileTimeSelect(type, values)}
          >
            {(items, { open }) => (
              <div className='time-picker-field' onClick={open}>
                <span style={{ color: value ? '#000' : '#bfbfbf' }}>
                  {value
                    ? moment(value, 'HH:mm').format('h:mm A')
                    : `選擇${label}`}
                </span>
                <DownOutlined style={{ color: '#bfbfbf', fontSize: '12px' }} />
              </div>
            )}
          </MobilePicker>
        </MobileTimePicker>
      )
    }

    return (
      <Select
        placeholder={`選擇${label}`}
        onChange={type === 'start' ? handleStartChange : handleEndChange}
        value={value}
        style={{ width: '100%' }}
      >
        {(type === 'start' ? startOptions : endOptions).map((time) => (
          <Option key={time} value={time}>
            {moment(time, 'HH:mm').format('h:mm A')}
          </Option>
        ))}
      </Select>
    )
  }

  // 修改服務選擇部分
  const renderServiceSelector = () => {
    if (isMobileView) {
      return (
        <Select
          mode='multiple'
          placeholder='選擇服務'
          onChange={(value) => {
            if (value.includes('所有服務')) {
              form.setFieldsValue({
                service: ['所有服務']
              })
            }
            handleFormChange()
          }}
          style={{ width: '100%' }}
          options={[
            { label: '所有服務', value: '所有服務' },
            ...products.map((product) => ({
              label: product.name,
              value: product._id
            }))
          ]}
        />
      )
    }

    return (
      <Select
        mode='multiple'
        placeholder='選擇服務'
        onChange={(value) => {
          if (value.includes('所有服務')) {
            form.setFieldsValue({
              service: ['所有服務']
            })
          }
          handleFormChange()
        }}
        style={{ width: '100%' }}
      >
        <Option value='所有服務'>所有服務</Option>
        {products.map((product) => (
          <Option key={product._id} value={product._id}>
            {product.name}
          </Option>
        ))}
      </Select>
    )
  }

  return (
    <Container>
      <ContentContainer>
        <IntervalSection title='預設服務時間間隔'>
          <Select
            value={defaultInterval}
            onChange={handleIntervalChange}
            style={{ width: '100%' }}
          >
            {[5, 10, 15, 20, 30, 45, 60, 90, 120].map((interval) => (
              <Option key={interval} value={interval}>
                {interval < 60
                  ? `${interval} 分鐘`
                  : `${Math.floor(interval / 60)} 小時${
                      interval % 60 ? ` ${interval % 60} 分鐘` : ''
                    }`}
              </Option>
            ))}
          </Select>
        </IntervalSection>

        {Object.entries(openingHours).map(([day, data]) =>
          renderDayCard(day, data)
        )}

        <ButtonGroup>
          <StyledButton type='primary' onClick={handleSave}>
            儲存設定
          </StyledButton>
        </ButtonGroup>

        {isMobileView && (
          <FixedButtonContainer>
            <StyledButton type='primary' onClick={handleSave} block>
              儲存設定
            </StyledButton>
          </FixedButtonContainer>
        )}

        <CopyModal
          title='複製工作時段'
          open={isCopyModalVisible}
          onOk={handleCopyConfirm}
          onCancel={() => {
            setIsCopyModalVisible(false)
            setSelectedDays([])
          }}
          okText='確認複製'
          cancelText='取消'
        >
          <p style={{ margin: '0px' }}>請選擇要複製到哪些星期：</p>
          <div className='days-grid'>
            {Object.keys(openingHours)
              .filter((day) => day !== selectedDayToCopy)
              .map((day) => (
                <DayCheckbox
                  key={day}
                  value={day}
                  checked={selectedDays.includes(day)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedDays([...selectedDays, day])
                    } else {
                      setSelectedDays(selectedDays.filter((d) => d !== day))
                    }
                  }}
                >
                  {day}
                </DayCheckbox>
              ))}
          </div>
        </CopyModal>

        <StyledModal
          title={`${
            currentPeriodIndex !== null ? '編輯' : '新增'
          }時段: ${currentDay}`}
          open={isModalVisible}
          onOk={handleModalOk}
          onCancel={handleModalCancel}
          okButtonProps={{ disabled: !isFormComplete }}
          okText='確認'
          cancelText='取消'
        >
          {warningText && <WarningText>{warningText}</WarningText>}
          <Form form={form} layout='vertical' onValuesChange={handleFormChange}>
            <Form.Item
              name='start'
              label='開始時間'
              rules={[{ required: true, message: '請選擇開始時間' }]}
            >
              {renderTimeSelector(
                'start',
                '開始時間',
                form.getFieldValue('start')
              )}
            </Form.Item>
            <Form.Item
              name='end'
              label='結束時間'
              rules={[{ required: true, message: '請選擇結束時間' }]}
            >
              {renderTimeSelector('end', '結束時間', form.getFieldValue('end'))}
            </Form.Item>
            <Form.Item
              name='service'
              label='服務'
              rules={[{ required: true, message: '請選擇至少一項服務' }]}
            >
              {renderServiceSelector()}
            </Form.Item>
          </Form>
        </StyledModal>
      </ContentContainer>
    </Container>
  )
}

export default EmployeeWorkHours
